import env from '../../common/helpers/env'
import { getRoundValue } from 'yxyweb/common/helpers/util';
import uuid from 'uuid';
export const billCopy = (source, target) => {
  for (let key in target) {
    if (Array.isArray(target[key])) {
      var emptyRow = target[key][0];
      if (Array.isArray(source[key])) {
        source[key].forEach(item => {
          if (!emptyRow) return;
          billCopy(item, emptyRow);
        });
      }
    } else {
      source[key] = target[key];
    }
  }
  return source;
};
export const billMerge = (source, target, condition = {}) => {
  if (!source && !target || typeof target !== 'object') {
    return null;
  }
  for (let key in target) {
    if (Array.isArray(target[key])) {
      if (Array.isArray(source[key])) {
        target[key].map(function (item, index) {
          let selfCondition = condition[key];
          if (selfCondition && selfCondition.length > 0) {
            billMerge(source[key][selfCondition[index]], item);
          } else {
            if (source[key][index]) {
              billMerge(source[key][index], item);
            } else {
              source[key][index] = item;
            }
          }
        })
      } else {
        source[key] = target[key];
      }
    } else {
      source[key] = target[key];
    }
  }

  return source;
};
export const setVmParams = (viewmodel, key, value) => {
  if (!viewmodel.getParams()) return;
  viewmodel.getParams()[key] = value;
};
export const getVmParams = (viewmodel, key) => {
  if (!viewmodel.getParams()) return;
  return viewmodel.getParams()[key];
}
export const doProxy = (params, callback, data) => {
  let proxy = cb.rest.DynamicProxy.create({
    doProxy: {
      url: params.cSvcUrl,
      method: params.cHttpMethod,
      options: params.options
    }
  });
  if (params.options && params.options.async === false) {
    const ajaxResult = proxy.doProxy(data);
    callback(ajaxResult.error, ajaxResult.result);
  } else {
    proxy.doProxy(data, callback);
  }
  // proxy.doProxy(data, function(err, suc) {
  //   if (err) {
  //     if (err.message) {
  //       alert(err.message);
  //     } else {
  //       alert(err.code);
  //     }
  //     cb.utils.loadingControl.end();
  //     return;
  //   }
  //   if (callback) callback(suc)
  // });
};

export const fetchMeta = (billNo, params, callback) => {
  let url = '/meta';
  let proxy = cb.rest.DynamicProxy.create({
    getMeta: {
      url: url,
      method: 'POST',
      options: Object.assign({
        uniform: false
      }, params.options)
    }
  });
  let postData = Object.assign({}, params, {
    billNo: billNo,
    type: 'bill'
  });
  proxy.getMeta(postData, callback);

}
export const todo = (self, act, viewmodel, params) => {
  if (act && self.action()[act.toLowerCase()]) {
    let data = {
      cancel: false,
      params: params
    };
    let Act = act.replace(/(\w)/, function (v) {
      return v.toUpperCase()
    }) //首字母大写
    console.log('Voucher-- ' + act + ' click');
    let beforeAct = (beforeActData, callback) => {
      return viewmodel.promiseExecute('before' + Act, beforeActData, function () {
        if (params && params.disabledCallback)
          params.disabledCallback();
        callback && callback();
      });
    }
    if (!viewmodel.execute('before' + Act + 'Execute', data) || data.cancel) return true;
    let billNo = getVmParams(viewmodel, 'billNo');
    let afterAct = (afterActData, callback) => {
      if (params && params.enabledCallback)
        params.enabledCallback();
      return viewmodel.promiseExecute('after' + Act, afterActData, function () {
        callback && callback(afterActData)
      });
    }
    let action = self.action()[act.toLowerCase()];
    action(billNo, viewmodel, params, beforeAct, afterAct);

  } else {
    if (viewmodel.hasEvent(act)) {
      viewmodel.execute(act, params);
      console.log('Voucher-- ' + act + ' click');
      return;
    }
    console.log('voucher->do——' + act + '方法不存在');
  }
};
export const check = (billNo, viewmodel, params, beforeAct, _afterAct, cellCheck) => {
  if (!params) {
    return;
  }
  params = JSON.parse(JSON.stringify(params));
  const checkKey = params.key;
  let checkModel;
  if (!cellCheck) {
    checkModel = viewmodel.get(checkKey);
    if (checkModel)
      checkModel.setChecking(true);
    params.location = '-1';
    params.async = false;
  }
  if (typeof params.value === 'object')
    params.value = JSON.stringify(params.value);
  //params.childAttribute = common.getVmParams(viewmodel, 'childrenField');
  let data = viewmodel.collectData(true);
  //data[params.key] = params.value; //赋新值
  let postData = {
    billnum: billNo,
    item: JSON.stringify(params),
    data: JSON.stringify(data)
  };
  let beforeActData = {
    params: params,
    data: postData
  }
  beforeAct(beforeActData, function () {
    const suffix = (params.childrenField ? params.childrenField + '.' + checkKey : checkKey).trim().toLocaleLowerCase();
    const configParams = viewmodel.allActions && viewmodel.allActions.find(x => {
      return x.cCommand && x.cCommand.trim().toLocaleLowerCase() === `cmdcheck_${suffix}`;
    });
    const options = configParams && configParams.cSvcUrl ? {
      cSvcUrl: configParams.cSvcUrl,
      cHttpMethod: configParams.cHttpMethod || 'POST'
    } : {
        cSvcUrl: 'bill/check',
        cHttpMethod: 'POST'
      };
    if (params.async === false)
      options.options = { async: false };
    let callback = function (err, suc) {
      if (!err) {
        if (suc) {
          if (cellCheck) {
            let gridModel = viewmodel.get(params.childrenField);
            let oldRowData = gridModel.getRow(params.location);
            const condition = {};
            for (let key in suc) {
              if (Array.isArray(suc[key]) && viewmodel.get(key) && viewmodel.get(key).getViewRowIndexes && viewmodel.get(key).getViewRowIndexes().length) {
                condition[key] = viewmodel.get(key).getViewRowIndexes();
              }
            }
            let newData = billMerge(oldRowData, suc, condition);
            gridModel.updateRow(params.location, newData);
          } else {
            let newData = billMerge(viewmodel.collectData(true), suc);
            viewmodel.loadDirtyData(newData);
          }
        }
      }
      let afterActData = {
        params,
        err: err,
        res: suc
      }
      _afterAct(afterActData, afterAct)
      if (!checkModel) return;
      checkModel.setCheckMsg(err ? err.message : null);
      checkModel.setChecking(false);
    }
    doProxy(options, callback, postData);
  })

};
export const columnsetting = (billNo, viewmodel, params, _afterAct) => {
  viewmodel.get(params.name).getTitleData(billNo, viewmodel.getParams().tplid, params.code);
  _afterAct()
};

const _setSates = function (viewmodel, states) {
  if (!viewmodel.execute('beforeSetState', states)) return
  if (states.length == 1) {
    let buttons = states[0].items.filter(x => x.cGroup == 'toolbaritem');
    for (let button of buttons) {
      let model = viewmodel.get(button.cName);
      let visible = button.bVisible;
      let disabled = !button.bEnable;
      if (model) {
        model.setDisabled(disabled);
        model.setVisible(visible);
      }
    }
  }
  if (!viewmodel.execute('afterSetState', states)) return
}
export const setState = function (viewmodel) {
  let mode = getMode(viewmodel);
  let allAtates = viewmodel.get('states');
  if (allAtates && allAtates.length > 0) {
    let data = viewmodel.collectData(true);
    let conditionStates = allAtates.filter(x => x.condition && eval(x.condition));
    let states;
    if (conditionStates && conditionStates.length > 0) {
      states = conditionStates;
    } else {
      let normalStates = allAtates.filter(x => (x.code) == mode);
      states = normalStates;
    }
    _setSates(viewmodel, states);


  }
};
export const storeVmInstance = (billNo, vm) => {
  let viewModelCache = cb.cache.viewModels.get(billNo);
  if (!viewModelCache) {
    viewModelCache = [];
    cb.cache.viewModels.set(billNo, viewModelCache);
  }
  viewModelCache.push(vm);
}

export const createDownloadForm = (url, params) => {
  console.log('createDownloadForm params:');
  console.log(params);
  const eleForm = document.createElement('form')
  eleForm.method = 'post'
  // eleForm.target = '_blank'
  eleForm.action = url
  eleForm.style.display = 'none'

  const eleInput = document.createElement('input')
  eleInput.name = 'json'
  eleInput.value = JSON.stringify(params)

  document.body.appendChild(eleForm)
  eleForm.appendChild(eleInput)
  eleForm.submit()
  document.body.removeChild(eleForm)
}
export const doService = (billNo, viewmodel, params, beforeAct, _afterAct, callback) => {
  let data = viewmodel.getNecessaryData();
  let postData = {
    billnum: billNo,
    data: JSON.stringify(data)
  };
  if (beforeAct) {
    let beforeActData = {
      params: params,
      data: postData
    };
    beforeAct(beforeActData, function () {
      if (callback) {
        callback(viewmodel, postData, params, _afterAct)
      }
    })
  } else {
    if (callback) {
      callback(viewmodel, postData, params, _afterAct)
    }
  }
}
export const getGridModel = (viewmodel, params = {}) => {
  let gridModel = {};
  if (params && params['childrenField']) {
    gridModel = viewmodel.get(params['childrenField']);
  } else if (params && params.params && params.params.childrenField) {
    gridModel = viewmodel.get(params.params['childrenField']);
  } else {
    gridModel = viewmodel.getGridModel()
  }
  return gridModel;
}
export const setRenderReadOnly = (viewmodel) => {
  let mode = getMode(viewmodel);
  let readOnly = true;
  switch (mode) {
    case env.VOUCHER_STATE_ADD:
      readOnly = false;
      break;
    case env.VOUCHER_STATE_EDIT:
      readOnly = false;
      break;
    case env.VOUCHER_STATE_BROWSE:
      readOnly = true
      break;
  }
  viewmodel.setReadOnly(readOnly);
};
export const edit = (billNo, viewmodel, params, beforeAct, _afterAct) => {
  const mode = env.VOUCHER_STATE_EDIT;
  if (viewmodel.getParams().multitpl) {
    cb.loader.runCommandLine('bill', {
      billtype: 'voucher',
      billno: billNo,
      params: {
        mode,
        id: viewmodel.get('id') && viewmodel.get('id').getValue() || viewmodel.getParams().id
      }
    }, viewmodel);
    return;
  }
  beforeAct({ params }, function () {
    setMode(viewmodel, mode);
    setState(viewmodel);
    viewmodel.setReadOnly(false);
    const gridModels = viewmodel.getGridModels();
    gridModels.forEach(gridModel => {
      setGridActionStates(gridModel, viewmodel, mode);
    });
    _afterAct();
  })

};
let id = 1;
export const initVM = (err, result, billNo, params, extendCallback) => {
  if (err) {
    cb.utils.alert(JSON.stringify(err), 'error');
    console.error(err);
    cb.utils.loadingControl.end()
    return;
  }
  let func = new Function(result.vm);
  func();
  let defaultParams = {
    billNo: result.viewmeta.cBillNo,
    subId: result.viewmeta.cSubId,
    bMultiTpl: result.viewmeta.bAllowMultiTpl,
    bPrint: result.viewmeta.bPrintLimited,
    cardKey: result.viewmeta.cCardKey,
    caption: params && params.name || result.viewmeta.view.cTemplateTitle
  };
  if (result.querySchema) {
    const { condition } = result.querySchema;
    // defaultParams.condition = {};
    // condition.commonVOs.forEach(item => {
    //   defaultParams.condition[item.itemName] = item.value1;
    // });
    defaultParams.condition = condition;
  }
  let vm = new cb.viewmodels[result.viewmeta.vmName]();
  vm.setViewMeta(result.viewmeta);
  vm.id = id++
  cb.utils.extend(true, vm.getParams(), defaultParams, params);
  storeVmInstance(billNo, vm);
  vm.on('extendReady', function () {
    extendCallback(vm, result.viewmeta);
  });
  const { extscripturls } = result.viewmeta;
  if (extscripturls && extscripturls.length) {
    // extscripturls.push('http://resources.yonyoucloud.com/packages/TestExternal.js');
    try {
      cb.requireInner(extscripturls, function (external) {
        console.info('%c externaljs doAction', 'color:green');
        external.doAction('init', vm);
      }, function (error) {
        console.info('%c externaljs notFound', 'font-size:12pt;color:#860786');
      });
    } catch (e) {
      console.info('%c externaljs exception', 'font-size:12pt;color:#860786');
      console.error(e);
    }
  }
  window.yya = vm
  return {
    vm: vm,
    view: result.viewmeta
  };

}

export const emptyBill = (postData, params, callback) => {
  const param = params && params.cSvcUrl ? {
    cSvcUrl: params.cSvcUrl,
    cHttpMethod: params.cHttpMethod || 'POST'
  } : {
      cSvcUrl: 'bill/add',
      cHttpMethod: 'POST'
    };
  doProxy(param, callback, postData);
}

export const getWebUrl = (srv, url, callback) => {
  const config = {
    cSvcUrl: 'menu/geturl',
    cHttpMethod: 'GET'
  };
  const params = { srv, url };
  doProxy(config, function (err, result) {
    if (err) {
      cb.utils.alert(err.message, 'error');
      return;
    }
    callback(result);
  }, params);
}

export const commandLine = (billNo, viewmodel, params, beforeAct, _afterAct) => {
  let cmdParams = {};
  if (params.cmdParameter) {
    try {
      cmdParams = JSON.parse(params.cmdParameter);
    } catch (error) {
      console.error('command cParameters JSON格式错误-->' + params.cmdParameter)
      return
    }
  }
  let beforeActData = {
    params: Object.assign(params, cmdParams)
  }
  beforeAct(beforeActData, function () {
    cb.loader.runCommandLine('menu', params, viewmodel)
    _afterAct();
  })

}

export const doPrint = (data, params, callback) => {
  let proxy = cb.rest.DynamicProxy.create({
    getPrint: {
      url: "/files" + params.cSvcUrl,
      method: params.cHttpMethod,
      options: {
        uniform: false,
      }
    }
  });
  proxy.getPrint(data, callback);
}
export const getMode = (viewmodel) => {
  return getVmParams(viewmodel, 'mode') || env.VOUCHER_STATE_BROWSE;
}
export const setMode = function (viewmodel, value) {
  if (!viewmodel.execute('beforeSetMode', {
    oldValue: getMode(viewmodel),
    newValue: value
  })) return
  setVmParams(viewmodel, 'mode', value);
  viewmodel.execute('modeChange', value);
};
export const afterAct = function (data) {
  if (data && data.err) {
    cb.utils.loadingControl.end();
    cb.utils.alert(data.err.message, 'error');
  }
};

export const pull = function (viewModel, args) {
  let cmdParams, pullBillNo, domain;
  try {
    cmdParams = JSON.parse(args.cmdParameter);
    pullBillNo = cmdParams.billnumber;
    domain = cmdParams.domain;
    delete cmdParams.billnumber;
    delete cmdParams.domain;
  } catch (e) {
    console.error('pull action parameter error: ' + e.message);
  }
  if (!pullBillNo) return;
  const params = {
    action: 'pull',
    query: cmdParams,
    callback: function (args) {
      const beforePush = function (beforeActData, callback) {
        args.beforeAct(beforeActData, callback);
      }
      const afterPush = function (afterActData, callback) {
        args.afterAct(afterActData, callback);
      }
      push(viewModel, Object.assign({ domain: false }, args.params), args.data, beforePush, afterPush);
    }
  };
  if (domain) {
    cb.utils.getWebUrl(domain, `/meta/voucherlist/${pullBillNo}`, function (menuUrl) {
      // let menuUrl = `https://u8cbillnode-daily.yyuap.com/meta/voucherlist/${pullBillNo}?`
      const random = uuid();
      menuUrl = cb.rest._appendUrl(menuUrl, { random });
      cb.cache.set(random, params);
      cb.loader.runCommandLine('menu', {
        menuId: random,
        userClick: true,
        viewType: 'external',
        menuUrl
      }, viewModel);
    });
  } else {
    cb.loader.runCommandLine('bill', {
      billtype: 'voucherlist',
      billno: pullBillNo,
      params
    }, viewModel);
  }
}

export const push = function (viewModel, args, data, beforeAct, afterAct) {
  const { action, callback } = viewModel.getParams();
  if (action === 'pull') {
    args.disabledCallback = false;
    args.enabledCallback = false;
    const pushArgs = { params: args, data, beforeAct, afterAct };
    if (callback) {
      callback(pushArgs);
    } else {
      window.parent.postMessage({ key: 'callback', random: cb.rest.AppContext.query.random, args: pushArgs }, '*');
    }
    return;
  }
  const { cSvcUrl, cHttpMethod } = args;
  // cSvcUrl = '/makeBill/pullVoucher.do?code=st_storenotice_storein&targetBillNo=st_storein';
  const queryString = new cb.utils.queryString(cSvcUrl);
  const targetBillNo = queryString.get('targetBillNo'), domain = args.domain !== false && queryString.get('domain');
  if (!targetBillNo) return;
  const params = {
    mode: env.VOUCHER_STATE_ADD,
    cSvcUrl: cSvcUrl,
    cHttpMethod: cHttpMethod,
    action: 'push',
    domain: args.domain,
    pushKey: args.pushKey,
    data: data
  };
  const beforeActData = { params, args };
  beforeAct(beforeActData, function () {
    if (domain) {
      cb.utils.loadingControl.start();
      getWebUrl(domain, `/meta/voucher/${targetBillNo}`, function (menuUrl) {
        const random = uuid();
        menuUrl += `&random=${random}`;
        cb.cache.set(random, params);
        cb.loader.runCommandLine('menu', {
          menuId: random,
          userClick: true,
          viewType: 'external',
          delay: true,
          type: cb.rest.AppContext.query.debug && 'window',
          menuUrl
        }, viewModel);
      });
    } else {
      const args = params;
      args.mode = 'add';
      cb.loader.runCommandLine('bill', {
        billtype: 'voucher',
        billno: targetBillNo,
        override: args.domain === false,
        params: params
      }, viewModel);
    }
    afterAct();
  });
};

export const copy = function (viewModel, args, id, beforeAct, afterAct) {
  const { cSvcUrl, cHttpMethod } = args;
  // cSvcUrl = '/bill/copy';
  const params = {
    mode: env.VOUCHER_STATE_EDIT,
    cSvcUrl: cSvcUrl,
    cHttpMethod: cHttpMethod,
    action: 'copy',
    id: id
  };
  const beforeActData = { params };
  beforeAct(beforeActData, function () {
    cb.loader.runCommandLine('bill', {
      billtype: 'voucher',
      billno: getVmParams(viewModel, 'cardKey'),
      params: params
    }, viewModel);
    afterAct();
  });
};

export const setGridActionStates = function (gridModel, viewmodel, currentState) {
  const actions = gridModel.getCache('actions');
  if (!actions) return;
  const allStates = viewmodel.get('states');
  if (!allStates || !allStates.length) return;
  const anonymousFunctions = {};
  allStates.forEach(item => {
    if (!item.condition) return;
    anonymousFunctions[item.code] = new Function('data', `return ${item.condition};`);
  });
  const parentData = viewmodel.collectData(true);
  const params = viewmodel.getParams();
  const rows = gridModel.getRows();
  const actionsStates = [];
  rows.forEach(data => {
    data.parentdata = parentData;
    data.params = params;
    // const conditionStates = allStates.filter(x => x.condition && eval(x.condition));
    const conditionStates = allStates.filter(x => anonymousFunctions[x.code] && anonymousFunctions[x.code](data));
    const states = conditionStates && conditionStates.length
      ? conditionStates
      : allStates.filter(x => x.code === (currentState || env.VOUCHER_STATE_BROWSE));
    if (states.length !== 1) return;
    const actionState = {};
    actions.forEach(action => {
      const state = states[0].items.find(x => x.cName === action.cItemName);
      actionState[action.cItemName] = { visible: state.bVisible };
    });
    actionsStates.push(actionState);
  });
  gridModel.setActionsState(actionsStates);
}
export const jsons2csv = (json) => {
  let headers = Array.from(
    json
      .map((ele) => Object.keys(ele))
      .reduce((a, b) => new Set([...a, ...b]), [])
  );
  let separator = ",",
    enclosingCharacter = '"';
  let headerLabels = headers;
  let headerKeys = headers;
  if (isJsons(headers)) {
    headerLabels = headers.map((header) => header.label);
    headerKeys = headers.map((header) => header.key);
  }
  const getHeaderValue = (property, obj) => {
    const foundValue = property
      .replace(/\[([^\]]+)]/g, ".$1")
      .split(".")
      .reduce(function (o, p, i, arr) {
        if (o[p] === undefined) {
          arr.splice(1);
        } else {
          return o[p];
        }
      }, obj);
    return foundValue === undefined
      ? property in obj
        ? obj[property]
        : ""
      : foundValue;
  };
  const data = json.map((object) =>
    headerKeys.map((header) => getHeaderValue(header, object))
  );
  const newData = [headerLabels, ...data];
  return newData
    .filter((e) => e)
    .map((row) => row
        .map((element) =>
          typeof element === "undefined" || element === null ? "" : element
        )
        .map((column) => `${enclosingCharacter}${column}${enclosingCharacter}`)
        .join(separator)
    )
    .join(`\n`);
};
export const toCSV = (data) => {
  if (isJsons(data)) return jsons2csv(data);
  throw new TypeError(
    `数据格式错误 `
  );
};
export const isJsons = (array) =>{
 return Array.isArray(array) && array.every((row) => typeof row === "object" && !(row instanceof Array));
}
export const buildURI = function (data, filename) {
  const type = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ? "application/csv" : "text/csv";
  const csv = toCSV(data);
  const blob = new Blob(["\uFEFF", csv], { type });
  const dataURI = `data:${type};charset=utf-8,${"\uFEFF"}${csv}`;
  //blob下载（兼容IE）
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, filename);
  } else {
    const URL = window.URL || window.webkitURL;
    let hrefURL =typeof URL.createObjectURL === "undefined" ? dataURI : URL.createObjectURL(blob);
    //通过a标签模拟下载
    const a = document.createElement("a");
    a.download = filename;
    a.style.display = "none";
    a.href = hrefURL;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(hrefURL);
  }
};
export const excelOutPut = function(recordList,sum,columData,fileName,sheetName,gridModel,fileType){
  const XLSX = require('xlsx')
  let rows = [], copyObj = {}, addrow = {},newRows = [];
  let filterValue = 0;
  let batchOutputList = recordList;
  let sumRecordList = sum;
  const getCellText = function (cell, columnName) {
    if (cell == null)
      return cell;
    let columnModel = gridModel.getEditRowModel().get(columnName);
    if (!(columnModel instanceof cb.models.BaseModel))
      return cell;
    let controlType = columnModel._get_data('cControlType');
    controlType = controlType && controlType.trim().toLocaleLowerCase();
    let textField = columnModel._get_data('textField');
    if (controlType === 'refer' || controlType === 'treerefer' || controlType === 'listrefer')
      return typeof cell === 'object' ? (cell[textField] != null ? cell[textField] : null) : cell;
    if (controlType === 'select' || controlType === 'radio' || controlType === "checkboxenum") {
      if (cell == null)
        return cell;
      let multiple = columnModel._get_data('multiple');
      let keyMap = columnModel._get_data('keyMap');
      if (multiple) {
        let items = [];
        if (typeof cell !== 'object') {
          cell.split(',').forEach(function (item) {
            if (!keyMap[item]) return;
            items.push(keyMap[item][textField]);
          });
          cell = items.join('/');
        } else if (cb.utils.isArray(cell)) {
          cell.forEach(function (item) {
            items.push(item[textField]);
          });
          cell = items.join('/');
        }
      } else if (typeof cell !== 'object') {
        let obj = keyMap[cell];
        if (!obj)
          obj = keyMap[cb.utils.getBooleanValue(cell)];
        cell = obj;
      }
      return cell;
      return cell && cell[textField];
    }
    if (controlType === 'tag' || controlType === 'attachment' || controlType === 'checkboxgroup') {
      var items = [];
      cell.forEach(function (item) {
        items.push(item[textField]);
      });
      return items;
    }
    if (controlType === 'cascader' && columnModel._get_data('dataSourceReady'))
      return cell ? columnModel.getNodesByKeys(cell)[0][columnModel._get_data('mergeField') || 'mergername'] : cell;
    return cell;
  }
  if(batchOutputList.length > 0){
    for (let i = 0; i < batchOutputList.length; i++) {
      let rowObj = {};
      for (let obj in columData) {
        let colWidth = false
        let heardName = columData[obj].cShowCaption ? columData[obj].cShowCaption : columData[obj].cCaption;
        let copyCol = {};
        if (columData[obj].bShowIt && !columData[obj].bHidden) {
          if(columData[obj].parent && (columData[obj].parent.cShowCaption||columData[obj].parent.cCaption)){
            heardName = (columData[obj].parent.cShowCaption ? columData[obj].parent.cShowCaption : columData[obj].parent.cCaption) + heardName;
            colWidth = true;
          }
          let rowObjDetails = batchOutputList[i];
          if(i === 0){
            copyCol.colWidth = colWidth;
            copyCol.cShowCaption = heardName;
            copyCol.cFormatData = columData[obj].cFormatData;
            copyCol.iNumPoint = columData[obj].iNumPoint;
            copyCol.cControlType = columData[obj].cControlType;
            copyCol.cEnumString = columData[obj].cEnumString;
            copyCol.iColWidth = columData[obj].iColWidth;
            copyObj[obj] = copyCol;
          }
          let enumValue = null;
          let isRowObj = rowObjDetails[obj] != undefined ? true : false;
          if (columData[obj].cEnumString && isRowObj) {
            if(gridModel){
              enumValue =getCellText(rowObjDetails[obj], obj) ? getCellText(rowObjDetails[obj], obj).text : null;
            }
          }
          let newHeardName = isNaN(heardName) ? heardName : " "+ heardName;
          rowObj[newHeardName] = enumValue ? enumValue : rowObjDetails[obj];//行数据和表头字段对应
        }
      }
      rows.push(rowObj);
    }
  }
  if (!!sumRecordList && sumRecordList.length > 0 && rows.length > 0) {
    let newObj = {};
    for (let obj in rows[0]) {
      addrow[obj] = undefined;
    }
    for (let key in sumRecordList[0]) {
      newObj = columData[key]
      if (newObj.bShowIt && !newObj.bHidden && (newObj.cShowCaption||newObj.cCaption)) {
        let tag = newObj.cShowCaption ? newObj.cShowCaption : newObj.cCaption;
        let newTag = isNaN(tag)? tag : " "+ tag
        if (newObj.parent && (newObj.parent.cShowCaption||newObj.parent.cCaption)) {
          tag = (newObj.parent.cShowCaption ? newObj.parent.cShowCaption : newObj.parent.cCaption) + tag;
          newTag = isNaN(tag)? tag : " "+ tag
        }
        if((newObj.cItemName || newObj.fieldName) == key&& newObj.bNeedSum && rows[0].hasOwnProperty(newTag)){
          addrow[newTag] = sumRecordList[0][key];
        }
        else{
          addrow[newTag] = undefined;
        }
      }
    }
    let addrow_value = Object.values(addrow);
    filterValue = addrow_value.filter(item => item != undefined).length;
    if (filterValue > 0) {
      let sumValue = getObjectFirst(addrow)
      rows.push(addrow);
      if(sumValue && sumValue.value){//第一列有合计数值
        let mapRows = rows && rows.map((item, index)=>{
          return Object.assign({"":""}, item);
        })
        // mapRows.push(Object.assign({"":""}, addrow));
        newRows = mapRows;
      }
      else{
        newRows = rows
      }

    }
    else{
      newRows = rows
    }
  }
  else{
    newRows = rows
  }
  if (newRows && newRows.length > 0) {
    if(fileType){
      let filename = sheetName+".csv"
      let addrowKey = Object.keys(addrow)
      if(addrowKey.length > 0){
      let total = newRows[newRows.length-1]
      let totalKey = Object.keys(total)[0]
      if(!total[totalKey]){
        total[totalKey] = "合计"
        newRows.splice(newRows.length-1,1,total)
      }
      }
      this.buildURI(newRows,filename)
      return
    }
    let sheet = XLSX.utils.json_to_sheet(newRows);//根据数组生成相应的表格sheet
    let rowCount = newRows.length;//行数
    let colCount = Object.keys(newRows[0]).length//列数
    sheet['!cols'] = new Array(colCount);//列对象数组
    let rowAll = XLSX.utils.decode_range(sheet['!ref']);//所有单元格的范围
    for (let R = 0; R <= 1; ++R) {
      for (let C = rowAll.s.c; C <= rowAll.e.c; ++C) {
        if (R === 0) {
          // let excel_cell = { c: C, r: R };
          let cellNumber = XLSX.utils.encode_cell({ c: C, r: R })//将行列对象转换为A1字符串
          let colValue = sheet[cellNumber].v;
          for (let obj in copyObj) {
            colValue =  (colValue != undefined || colValue !="") ? colValue.replace(" ","") : colValue;
            if (copyObj[obj].cShowCaption === colValue) {
              sheet['!cols'][C] = { wpx: copyObj[obj].iColWidth }//加列宽
              let cFormatData = copyObj[obj].cFormatData;//日期
              let cControlType = copyObj[obj].cControlType;//类型
              let iNumPoint = copyObj[obj].iNumPoint;//小数
              // let enumString = copyObj[obj].cEnumString;//枚举
              if (cFormatData === 'YYYY-MM-DD') {
                let colAll = { s: { r: 1, c: C }, e: { r: rowCount, c: C } };
                for (let R = colAll.s.r; R <= colAll.e.r; ++R) {
                  let dataCell = { c: C, r: R };
                  let dataCellNum = XLSX.utils.encode_cell(dataCell);
                  let dateValue = /\d{4}-\d{1,2}-\d{1,2}/g.exec(sheet[dataCellNum].v)
                  if (dateValue != null || dateValue != undefined) {
                    sheet[dataCellNum].t = 'd';
                    sheet[dataCellNum].v = dateValue
                  }
                  else {
                    sheet[dataCellNum].t = 's';
                    sheet[dataCellNum].v = "";
                  }
                }

              }
              //计算列宽
              if (copyObj[obj].colWidth) {
                if (sheet[cellNumber].t === 's') {
                  let length = sheet[cellNumber].v.length;
                  let chaineseLen = /.*[\u4e00-\u9fa5]+.*$/.test(sheet[cellNumber].v) ? length * 2 : length;
                  let showLen = sheet['!cols'][C].wpx > width2px(chaineseLen + 2) ? sheet['!cols'][C].wpx : width2px(chaineseLen + 2)
                  sheet['!cols'][C] = { wpx:showLen  };
                }
              }
              switch (cControlType && cControlType.trim().toLocaleLowerCase()) {
                case 'inputnumber':
                case 'money':
                case 'price':
                  try {
                    if (!cFormatData || cFormatData == '') {
                      cFormatData = {};
                    } else {
                      cFormatData = JSON.parse(cFormatData);
                    }
                  } catch (e) {
                    cb.utils.alert('数量/金额/单价，预制错误！', 'error');
                  }
                  let decimal = cFormatData.decimal ? getPredicateValue(cFormatData.decimal) : null;
                  if (cControlType === 'money') {
                    if (decimal)
                      iNumPoint = decimal;
                    else
                      iNumPoint = cb.rest.AppContext.option.amountofdecimal;
                  } else if (cControlType === 'price') {
                    if (decimal)
                      iNumPoint = decimal;
                    else
                      iNumPoint = cb.rest.AppContext.option.monovalentdecimal;
                  } else {
                    if (decimal)
                      iNumPoint = decimal;
                    else
                      if (cb.utils.isEmpty(iNumPoint)) iNumPoint = null;
                  }
                  if (iNumPoint) {
                    let colAll = { s: { r: 1, c: C }, e: { r: rowCount, c: C } };
                    for (let R = colAll.s.r; R <= colAll.e.r; ++R) {
                      let dataCell = { c: C, r: R };
                      let dataCellNum = XLSX.utils.encode_cell(dataCell);
                      let decimalCount = cFormatData.splitter ? "#,##0.0" : "0.0"
                      for (let i = 1; i < iNumPoint; i++) {
                        decimalCount = decimalCount + "0";
                      }
                      sheet[dataCellNum].z = decimalCount;
                      sheet[dataCellNum].t = "n";
                    }
                  }
                  if (cControlType === 'money' || (cFormatData.decimal && cFormatData.decimal.indexOf("amountofdecimal"))) {
                    cFormatData.splitter = true
                    if (!iNumPoint) {
                      //小数位数没有时，循环该列
                      let colAll = { s: { r: 1, c: C }, e: { r: rowCount, c: C } };
                      for (let R = colAll.s.r; R <= colAll.e.r; ++R) {
                        let dataCell = { c: C, r: R };
                        let dataCellNum = XLSX.utils.encode_cell(dataCell);
                        sheet[dataCellNum].z = XLSX.SSF._table[3];//数字格式化，3是千分位格式0.00
                        sheet[dataCellNum].t = "n";
                      }
                    }
                  }
              }
            }
          }
        }
        else if(R === 1) {
          // let excel_cell = { c: C, r: R };//当前单元格地址
          let cellNumber = XLSX.utils.encode_cell({ c: C, r: R })//将行列对象转换为A1字符串
          // let a = XLSX.utils.encode_cell({ c: C, r: 0 })
          if (sheet[cellNumber].t === 'n' && sheet[cellNumber].v !== undefined) {
            let length = sheet[cellNumber].v.toString().length;
            //为小数时，不改变数据格式，增加列宽
            if (sheet[cellNumber].z) {
              let RegExp = /[0-9]+\.([0-9]*)/;
              let decimaLength = sheet[cellNumber].v.toString().replace(RegExp, "$1").length;
              length = length + decimaLength;
            }
            //长度超过12时，为了避免科学计数法问题，需要对单元格设置格式
            else if (length >= 12) {
              //单纯数字过长时，格式设为1
              let colAll = { s: { r: 1, c: C }, e: { r: rowCount, c: C } };
              for (let R = colAll.s.r; R <= colAll.e.r; ++R) {
                let dataCell = { c: C, r: R };
                let dataCellNum = XLSX.utils.encode_cell(dataCell);
                sheet[dataCellNum].z = XLSX.SSF._table[1];
              }
            }
            let newlen = sheet['!cols'][C].wpx > width2px(length + 2) ? sheet['!cols'][C].wpx : width2px(length + 2)
            sheet['!cols'][C] = { wpx: newlen };
          }else if (sheet[cellNumber].t === 'b') {
            let colAll = { s: { r: 1, c: C }, e: { r: rowCount, c: C } };
            for (let R = colAll.s.r; R <= colAll.e.r; ++R) {
              let dataCell = { c: C, r: R };
              let dataCellNum = XLSX.utils.encode_cell(dataCell);
              sheet[dataCellNum].t = 's';
              sheet[dataCellNum].v = sheet[dataCellNum].v ? '是' : '否';
              // sheet[dataCellNum].f = `IF(${sheet[dataCellNum].v},"是","否")`;
            }
          }
        }
      }
    }
    if (filterValue > 0) {
      let dataCell = { c: 0, r: rowCount };
      let dataCellNum = XLSX.utils.encode_cell(dataCell);
      sheet[dataCellNum].t = 's';
      sheet[dataCellNum].v = '合计';
    }

    let wb = XLSX.utils.book_new();
    //wb中增加一个sheet
    XLSX.utils.book_append_sheet(wb, sheet, sheetName);
    XLSX.writeFile(wb, fileName, {compression:true});// 导出所需Excel
  }
  else {
    cb.utils.alert('无数据可导出', 'warning')
  }
}
const getPredicateValue = formatValue => {
  const exp = /<%.*?%>/g;
  const items = formatValue.match(exp);
  if (!items)
    return formatValue;
  const values = {};
  let valid = true;
  items.forEach(item => {
    const predicate = item.substring(2, item.length - 2).split('.');
    if (predicate.length !== 2) {
      valid = false;
      return;
    }
    const obj = cb.rest.AppContext[predicate[0]];
    values[item] = obj && (cb.utils.isEmpty(obj[predicate[1]]) ? '' : obj[predicate[1]]);
  });
  if (!valid)
    return formatValue;
  return formatValue.replace(exp, function (key) {
    return values[key];
  });
}
const width2px = (width) => {
  if (width < 10) width = 10;
  return Math.floor((width + (Math.round(128 / 6)) / 256) * 6);
}
const getObjectFirst=(obj)=>{
  for(let key in obj){
    let value = {'value':obj[key],'key':key};
    return value
  }
}
cb.utils.formatNum = function (value, type) {
  if (!cb.rest.AppContext || !cb.rest.AppContext.option) return value;
  let { amountofdecimal = 2, monovalentdecimal = 2, numPoint_Rate = 2 } = cb.rest.AppContext.option;
  switch (type) {
    case 'money':
      return isNaN(Number(value)) ? 0 : Number(Number(getRoundValue(value, amountofdecimal)))
    case 'price':
      return isNaN(Number(value)) ? 0 : Number(Number(getRoundValue(value, monovalentdecimal)))
    case 'rate':
      return isNaN(Number(value)) ? 0 : Number(Number(getRoundValue(value, numPoint_Rate)))
    default:
      return value
  }
}

cb.utils.formatMoney = function (value) {
  return cb.utils.formatNum(value, 'money')
}

cb.utils.triggerReferBrowse = function (referModel, simpleVOs, treemapcondition) {
  if (!referModel) return;
  const enterParams = { model: referModel, browse: false };
  const filter = referModel.get('filter');
  if (cb.utils.isArray(simpleVOs)) {
    if(filter && filter.simpleVOs && cb.utils.isArray(filter.simpleVOs))
      simpleVOs = simpleVOs.concat(filter.simpleVOs)
    enterParams.condition = { isExtend: true, simpleVOs };
  } else {
    enterParams.mapCondition = simpleVOs;
  }
  if (treemapcondition) {
    enterParams.treeMapCondition = treemapcondition;
  }
  const vm = referModel.getCache('vm');
  if (vm) {
    vm.execute('pressEnter', enterParams);
  } else {
    referModel.browse(false, function (vm) {
      vm.on('getRefMetaReady', function () {
        vm.execute('pressEnter', enterParams);
      });
    });
  }
}

cb.utils.resetViewModelByViewMeta = function (container, viewModel) {
  if (!container.controls) return;
  const model = viewModel.get(container.childrenField || container.cCode);
  if (model && model instanceof cb.models.TagModel && model.get('convert')) { // tagModel 附件 convert=true
    resetViewModel(container, viewModel, model);
  }
}

const resetViewModel = function (container, viewModel, model) {
  container.controls.forEach(control => {
    if (control.controls)
      resetViewModel(control, viewModel, null);
    const headModel = viewModel.get(control.cItemName) || model;
    if (!headModel) return;
    headModel._set_data('bIsNull', control.bIsNull); // 适配附件必填项
  });
}


// WEBPACK FOOTER //
// ./src/yxyweb/client/common/common.js